import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponet = _resolveComponent("HeaderComponet")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_LanguageSelectorComponent = _resolveComponent("LanguageSelectorComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderComponet),
      _createVNode(_component_a_layout_content, { class: "min-h-screen" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_LanguageSelectorComponent),
      _createVNode(_component_FooterComponent)
    ]),
    _: 1
  }))
}